module.exports = __webpack_public_path__ + "static/media/street-light.dadf714c.jpg";